import {FC, useState} from 'react';
import {Box, IconButton, Typography, useMediaQuery} from '@mui/material';
import {ReactComponent as Profile} from '@icons/profile.svg';
import {ReactComponent as Arrow} from '@icons/arrow-down.svg';
import Dropdown from '@/shared/components/Dropdown';
import {BODY1, SUBTITLE2} from '@/utils/constants';
import {useAppDispatch} from '@/store/hooks';
import {getUserSelector, userLogout} from '@/store/user';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {userStorage} from '@/utils/services';
import {userDropdownStyle} from './UserDropdown.styles';
import {ROUTER_URL} from '@/utils/enums';
import { setNotifications } from '@/store/notification';

const UserDropdown: FC = () => {
  const {slug} = useParams();
  const [isOpened, setIsOpened] = useState(false);

  const user = useSelector(getUserSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width: 639.98px)');

  const handleLogout = () => {
    dispatch(userLogout());
    dispatch(setNotifications({notifications: [], target: 'unread'}));
    dispatch(setNotifications({notifications: [], target: 'all'}));
    navigate(`/${slug}`);
  };

  const handleProfileClick = () => {
    userStorage.set('activeTab', 'Settings');
    navigate(`/${slug}/profile`);
  };
  const handleNotificationClick = () => {
    userStorage.set('activeTab', 'Notifications');
    navigate(`/${slug}/profile/notifications`);
  };
  const handleContributionsClick = () => {
    userStorage.set('activeTab', 'Contributions');
    navigate(`/${slug}/profile/contributions`);
  };
  return (
    <Dropdown
      toggleContent={
        <Box sx={userDropdownStyle.wrap}>
          <IconButton sx={userDropdownStyle.button}>
            <Profile />
          </IconButton>
          <Box>
            <Typography
              sx={userDropdownStyle.name}
              variant={BODY1}
            >{`${user?.firstName} ${user?.lastName}`}</Typography>
            <Typography variant={SUBTITLE2} sx={userDropdownStyle.email}>
              {user?.email}
            </Typography>
          </Box>
          {!isMobile && (
            <IconButton sx={{...(isOpened && userDropdownStyle.rotateArrow)}}>
              <Arrow />
            </IconButton>
          )}
        </Box>
      }
      options={
        <Box sx={userDropdownStyle.options}>
          <Typography sx={userDropdownStyle.option} variant={BODY1} onClick={handleProfileClick}>
            Settings
          </Typography>
          <Typography sx={userDropdownStyle.option} variant={BODY1} onClick={handleNotificationClick}>
            Notifications
          </Typography>
          <Typography sx={userDropdownStyle.option} variant={BODY1} onClick={handleContributionsClick}>
            Contributions
          </Typography>
          <Typography sx={userDropdownStyle.option} variant={BODY1} onClick={handleLogout}>
            Log out
          </Typography>
        </Box>
      }
      open={isOpened}
      onOpen={() => {
        if (isMobile) {
          navigate(ROUTER_URL.USER_ACCOUNT_SETTINGS);
          return;
        }
        setIsOpened(true);
      }}
      onClose={() => setIsOpened(false)}
    />
  );
};

export default UserDropdown;
